var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['wrap-word', 'word-animation-'+_vm.animationCod ]},[_c('span',{class:['word', 'text-center']},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }